import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaEdit, FaTrash } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';

const TipoEnquadramento = () => {
  const [tiposEnquadramento, setTiposEnquadramento] = useState([]);
  const [orgaos, setOrgaos] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    tipo_enquadramento: '',
    sigla: '',
    id_orgao: '',
    ativo: true
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const carregarTiposEnquadramento = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/tipo-enquadramento`);
      if (!response.ok) {
        throw new Error('Erro ao buscar tipos de enquadramento');
      }

      const data = await response.json();

      const formatados = data.map((item) => ({
        id: item.id_tipo_enquadramento,
        tipo_enquadramento: item.nome_tipo_enquadramento,
        sigla: item.sigla || '',
        id_orgao: item.id_orgao ? String(item.id_orgao) : '',
        orgao_referencia: item.orgao_referencia || '',
        ativo: item.ativo
      }));

      setTiposEnquadramento(formatados);
    } catch (error) {
      console.error('Erro ao carregar tipos de enquadramento:', error);
      alert('Erro ao carregar tipos de enquadramento. Verifique a conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  const carregarOrgaos = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/orgaos-referencia`);

      if (!response.ok) {
        throw new Error('Erro ao buscar órgão de referência');
      }

      const data = await response.json();
      setOrgaos(data);
    } catch (error) {
      console.error('Erro ao carregar órgão de referência:', error);
      setOrgaos([]);
    }
  };

  useEffect(() => {
    carregarTiposEnquadramento();
    carregarOrgaos();
  }, []);

  const filteredTiposEnquadramento = tiposEnquadramento.filter((tipo) =>
    `${tipo.tipo_enquadramento} ${tipo.sigla} ${tipo.orgao_referencia}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const payload = {
        nome_tipo_enquadramento: formData.tipo_enquadramento,
        sigla: formData.sigla || null,
        id_orgao: formData.id_orgao ? Number(formData.id_orgao) : null,
        ativo: formData.ativo
      };

      if (editingId) {
        const response = await fetch(
          `${API_BASE_URL}/tipo-enquadramento/${editingId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar tipo de enquadramento');
        }

        const atualizado = await response.json();

        setTiposEnquadramento((prev) =>
          prev.map((tipo) =>
            tipo.id === editingId
              ? {
                  id: atualizado.id_tipo_enquadramento,
                  tipo_enquadramento: atualizado.nome_tipo_enquadramento,
                  sigla: atualizado.sigla || '',
                  id_orgao: atualizado.id_orgao ? String(atualizado.id_orgao) : '',
                  orgao_referencia: atualizado.orgao_referencia || '',
                  ativo: atualizado.ativo
                }
              : tipo
          )
        );
      } else {
        const response = await fetch(`${API_BASE_URL}/tipo-enquadramento`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erro ao criar tipo de enquadramento');
        }

        const criado = await response.json();

        setTiposEnquadramento((prev) => [
          ...prev,
          {
            id: criado.id_tipo_enquadramento,
            tipo_enquadramento: criado.nome_tipo_enquadramento,
            sigla: criado.sigla || '',
            id_orgao: criado.id_orgao ? String(criado.id_orgao) : '',
            orgao_referencia: criado.orgao_referencia || '',
            ativo: criado.ativo
          }
        ]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar tipo de enquadramento:', error);
      alert('Erro ao salvar tipo de enquadramento. Verifique os dados e tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (tipo) => {
    setFormData({
      tipo_enquadramento: tipo.tipo_enquadramento,
      sigla: tipo.sigla || '',
      id_orgao: tipo.id_orgao || '',
      ativo: tipo.ativo
    });
    setEditingId(tipo.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este tipo de enquadramento?')) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/tipo-enquadramento/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir tipo de enquadramento');
      }

      setTiposEnquadramento((prev) => prev.filter((tipo) => tipo.id !== id));
    } catch (error) {
      console.error('Erro ao excluir tipo de enquadramento:', error);
      alert('Erro ao excluir tipo de enquadramento. Tente novamente.');
    }
  };

  const resetForm = () => {
    setFormData({ tipo_enquadramento: '', sigla: '', id_orgao: '', ativo: true });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (id) => {
    const tipoSelecionado = tiposEnquadramento.find((tipo) => tipo.id === id);

    if (!tipoSelecionado) {
      return;
    }

    const novoAtivo = !tipoSelecionado.ativo;

    try {
      const response = await fetch(
        `${API_BASE_URL}/tipo-enquadramento/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            nome_tipo_enquadramento: tipoSelecionado.tipo_enquadramento,
            sigla: tipoSelecionado.sigla || null,
            id_orgao: tipoSelecionado.id_orgao ? Number(tipoSelecionado.id_orgao) : null,
            ativo: novoAtivo
          })
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status do tipo de enquadramento');
      }

      const atualizado = await response.json();

      setTiposEnquadramento((prev) =>
        prev.map((tipo) =>
          tipo.id === id ? { ...tipo, ativo: atualizado.ativo } : tipo
        )
      );
    } catch (error) {
      console.error('Erro ao atualizar status do tipo de enquadramento:', error);
      alert('Erro ao atualizar status do tipo de enquadramento. Tente novamente.');
    }
  };

  return (
    <div className="tabela-referencia-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Tipo de Enquadramento</h1>
        </div>
        {!showForm && (
          <button 
            className="btn-primary"
            onClick={() => setShowForm(true)}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            Cadastrar Tipo de Enquadramento
          </button>
        )}
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Tipo de Enquadramento' : 'Cadastrar Tipo de Enquadramento'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="tipo_enquadramento">Tipo de Enquadramento *</label>
              <input
                type="text"
                id="tipo_enquadramento"
                value={formData.tipo_enquadramento}
                onChange={(e) => setFormData({...formData, tipo_enquadramento: e.target.value})}
                required
                maxLength={100}
                placeholder="Digite o tipo de enquadramento"
              />
            </div>

            <div className="form-group">
              <Toggle
                id="ativo"
                label="Status:"
                checked={formData.ativo}
                onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="id_orgao">REF (Órgão de Referência)</label>
                <select
                  id="id_orgao"
                  value={formData.id_orgao}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedOrgao = orgaos.find(
                      (o) => String(o.id_orgao_referencia) === String(selectedId)
                    );

                    setFormData((prev) => ({
                      ...prev,
                      id_orgao: selectedId,
                      sigla: selectedOrgao?.sigla || prev.sigla
                    }));
                  }}
                >
                  <option value="">Selecione um órgão de referência</option>
                  {orgaos.map((orgao) => (
                    <option
                      key={orgao.id_orgao_referencia}
                      value={orgao.id_orgao_referencia}
                    >
                      {orgao.nome_orgao_referencia}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="sigla">Sigla</label>
                <input
                  type="text"
                  id="sigla"
                  value={formData.sigla}
                  onChange={(e) =>
                    setFormData({ ...formData, sigla: e.target.value })
                  }
                  maxLength={20}
                  placeholder="Ex: TE"
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                Cancelar
              </button>
              <button type="submit" className="btn-primary">
                {editingId ? 'Atualizar' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
              <input
                type="text"
                placeholder="Pesquisar tipos de enquadramento..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>
                {loading
                  ? 'Carregando tipos de enquadramento...'
                  : `${filteredTiposEnquadramento.length} registro(s) encontrado(s)`}
              </span>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table tipo-enquadramento-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Tipo de Enquadramento</th>
                  <th className="col-nome">REF</th>
                  <th className="col-sigla">Sigla</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredTiposEnquadramento.map(tipo => (
                  <tr key={tipo.id}>
                    <td className="col-id">{tipo.id}</td>
                    <td className="col-nome">{tipo.tipo_enquadramento}</td>
                    <td className="col-nome">{tipo.orgao_referencia || ''}</td>
                    <td className="col-sigla">
                      {tipo.sigla ? <span className="sigla-badge">{tipo.sigla}</span> : ''}
                    </td>
                    <td className="col-status status-cell">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          checked={tipo.ativo}
                          onChange={() => handleToggleStatus(tipo.id)}
                          id={`toggle-${tipo.id}`}
                        />
                      </div>
                    </td>
                    <td className="col-acoes acoes-col">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(tipo)}
                          title="Editar"
                        >
                          <FaEdit size={16} />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(tipo.id)}
                          title="Excluir"
                        >
                          <FaTrash size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredTiposEnquadramento.length === 0 && !loading && (
              <div className="empty-state">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="M21 21l-4.35-4.35"/>
                </svg>
                <h3>Nenhum tipo de enquadramento encontrado</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre um novo tipo de enquadramento.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TipoEnquadramento;
